"use client"

import * as React from "react"
import { format } from "date-fns"
import { DayPickerSingleProps, Matcher } from "react-day-picker"

import { cn } from "../../lib/utils"
import { Button } from "../Button"
import { Calendar } from "../Calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../Popover"
import { TbCalendar } from "react-icons/tb"
import { t } from "i18next"

interface DayPickerProps extends DayPickerSingleProps {
  disabled?: Matcher | undefined;
  algin?: "start" | "end" | "center";
  side?: "left" | "right" | "bottom" | "top"; 
  closeWhenSelect?: boolean;
}

export function DatePicker({ className, selected, onSelect, disabled = undefined, algin = "center", side = "bottom", closeWhenSelect = false }: DayPickerProps) {
  let [open, setOpen] = React.useState(false)

  function handleDayClick() {
    if(closeWhenSelect) {
      setTimeout(function () {
        setOpen(false)
      }, 200) 
    }
  }

  return (
    <Popover open={open} onOpenChange={() => setOpen(!open)}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size="datepicker"
          className={cn(
            className,
            "w-min-content justify-start text-left font-normal",
            !selected && "text-muted-foreground"
          )}
        >
          <TbCalendar className="mr-2 h-4 w-4" />
          {selected ? format(selected, "dd.MM.y") : <span>{t("pick_a_date")}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align={algin} side={side}>
        <Calendar 
          mode="single" 
          selected={selected} 
          defaultMonth={selected}
          onSelect={onSelect} 
          onDayClick={() => handleDayClick()} 
          initialFocus 
          disabled={disabled} 
        />
      </PopoverContent>
    </Popover>
  );
}